import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home/Home";
import Group from "./pages/group/Group";
import Whatwedo from "./pages/whatwedo/Whatwedo";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import "./App.css";
import BoardOfDirectors from "./pages/team/BoardofDirectors";
import Team from "./pages/team/Team";
import Career from "./pages/career/Career";
import Events from "./pages/events/Events";
import AOS from "aos";
import "aos/dist/aos.css";
import Contact from "./components/contact/Contact";
import NotFound from "./pages/notfound/NotFound";

import PrivacyPolicy from "./pages/privacy/PrivacyPolicy";
import CookiePolicy from "./pages/privacy/CookiePolicy";
import TermsAndConditions from "./pages/privacy/TermsAndConditions";
import FAQs from "./pages/faqs/FAQs";
import CookieConsentBanner from "./components/cookie/CookieConsent";
// eslint-disable-next-line no-unused-vars
import FloatingButtons from "./components/FloatingButtons";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 650,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <div className="App">
      <Navbar />
      <div>
        <Routes>
          <Route index exact path="/" element={<Home />} />
          <Route exact path="/career" element={<Career />} />
          <Route exact path="/events" element={<Events />} />
          <Route exact path="/group" element={<Group />} />
          <Route exact path="/what-we-do" element={<Whatwedo />} />

          <Route
            exact
            path="/board-of-directors"
            element={<BoardOfDirectors />}
          />
          <Route exact path="/management-team" element={<Team />} />

          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/cookie-policy" element={<CookiePolicy />} />
          <Route
            exact
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route exact path="/faqs" element={<FAQs />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
      <CookieConsentBanner />
      <FloatingButtons />
    </div>
  );
};

export default App;
